import { render, staticRenderFns } from "./ComponentAdminLogin.vue?vue&type=template&id=064676f8&scoped=true"
import script from "./ComponentAdminLogin.vue?vue&type=script&lang=js"
export * from "./ComponentAdminLogin.vue?vue&type=script&lang=js"
import style0 from "./ComponentAdminLogin.vue?vue&type=style&index=0&id=064676f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064676f8",
  null
  
)

export default component.exports